import React, { useState, useEffect, useRef } from 'react';

import { Link } from 'react-router-dom';

import CheeseMaggiImg from '../assets/Cheese Maggi.png';

import PeanutChatkaraImg from '../assets/Peanut Chatkara.jpeg';

import OnionFrittersImg from '../assets/Onion Fritters.png';

import AssortedFritterImg from '../assets/Assorted Fritter.png';

import PaneerFrittersImg from '../assets/Paneer Fritters.png';

import CheeseGarlicBreadImg from '../assets/Cheese Garlic Bread.png';

import DalFryImg from '../assets/Dal Fry.png';

import DalTadkaImg from '../assets/Dal Tadka.png';

import DhaabeKiDalImg from '../assets/Dhaabe ki Dal.png';

import DalMakhaniImg from '../assets/Dal Makhani.png';

import PalakPaneerImg from '../assets/Palak Paneer.png';

import PaneerDoPyazaImg from '../assets/Paneer Do Pyaza.png';

import GulabJamunWithIceCreamImg from '../assets/Gulab Jamun with Ice Cream .png';

import IceCreamAllFlavorsImg from '../assets/Ice Cream (All Flavors) .png';

import ChocolateShotsImg from '../assets/Chocolate Shots.png';

import HotChocolateBrownieImg from '../assets/Hot Chocolate Brownie.png';

import SizzlingBrownieImg from '../assets/Sizzling Brownie.png';

import GulabJamun2PcsImg from '../assets/Gulab Jamun (2 Pcs).png';

import MasalaTeaImg from '../assets/Masala Tea.png';

import GingerTeaImg from '../assets/Ginger Tea.png';

import GreenTeaImg from '../assets/Green Tea .png';

import LemonTeaImg from '../assets/Lemon Tea.png';

import BlackTeaImg from '../assets/Black Tea.png';

import LatteCoffeeImg from '../assets/Latte Coffee.png';
import ContactSection from './ContactSection';




const menuTabs = ['Appetizers', 'Main Courses', 'Desserts', 'Beverages'];

const menuItems = [
  // Appetizers
  { title: 'Cheese Maggi', price: 65, category: 'Appetizers', description: "Who doesn't love cheese, especially with maggi", img: CheeseMaggiImg },
  { title: 'Peanut Chatkara', price: 95, category: 'Appetizers', description: "Peanuts tossed with onion, tomato, cucumber with tangy flavour of lemon and spices", img: PeanutChatkaraImg },
  { title: 'Onion Fritters', price: 115, category: 'Appetizers', description: "Onion dipped in gram flour and fried to perfection", img: OnionFrittersImg },
  { title: 'Assorted Fritter', price: 125, category: 'Appetizers', description: "Variety of pakoras served together, onion, paneer, gobi", img: AssortedFritterImg },
  { title: 'Paneer Fritters', price: 135, category: 'Appetizers', description: "Paneer Pakoras full with flavour and taste", img: PaneerFrittersImg },
  { title: 'Cheese Garlic Bread', price: 135, category: 'Appetizers', description: "Perfectly baked garlic bread topped with Mozzarella cheese", img: CheeseGarlicBreadImg },

  // Main Courses
  { title: 'Dal Fry', price: 145, category: 'Main Courses', description: "Yellow lentils cooked and tempered with desi ghee", img: DalFryImg },
  { title: 'Dal Tadka', price: 155, category: 'Main Courses', description: "A delicious and yummy lentil curry", img: DalTadkaImg },
  { title: 'Dhaabe ki Dal', price: 145, category: 'Main Courses', description: "Yellow dal tempered with garlic and desi ghee", img: DhaabeKiDalImg },
  { title: 'Dal Makhani', price: 165, category: 'Main Courses', description: "Black lentils cooked with butter & cream", img: DalMakhaniImg },
  { title: 'Palak Paneer', price: 185, category: 'Main Courses', description: "Paneer and spinach tempered with garlic and spices", img: PalakPaneerImg },
  { title: 'Paneer Do Pyaza', price: 185, category: 'Main Courses', description: "Paneer cooked with whole spices in onion gravy", img: PaneerDoPyazaImg },

  // Desserts
  { title: 'Gulab Jamun with Ice Cream', price: 85, category: 'Desserts', description: "Gulab jamun served with vanilla ice cream", img: GulabJamunWithIceCreamImg },
  { title: 'Ice Cream (All Flavors)', price: 90, category: 'Desserts', description: "Double scoop of your favorite ice cream", img: IceCreamAllFlavorsImg },
  { title: 'Chocolate Shots', price: 95, category: 'Desserts', description: "Light texture, intense chocolate flavor", img: ChocolateShotsImg },
  { title: 'Hot Chocolate Brownie', price: 75, category: 'Desserts', description: "Chocolate brownie topped with hot sauce", img: HotChocolateBrownieImg },
  { title: 'Sizzling Brownie', price: 120, category: 'Desserts', description: "Brownie, ice cream, and chocolate sauce", img: SizzlingBrownieImg },
  { title: 'Gulab Jamun (2 Pcs)', price: 55, category: 'Desserts', description: "Soft gulab jamuns that melt in your mouth", img: GulabJamun2PcsImg },

  // Beverages
  { title: 'Masala Tea', price: 25, category: 'Beverages', description: "Spicy blend infused with best tea leaves", img: MasalaTeaImg },
  { title: 'Ginger Tea', price: 25, category: 'Beverages', description: "Refreshing adrak wali chai", img: GingerTeaImg },
  { title: 'Green Tea', price: 25, category: 'Beverages', description: "Refreshing, relaxing and healthy", img: GreenTeaImg },
  { title: 'Lemon Tea', price: 25, category: 'Beverages', description: "Low-calorie tea with vitamins", img: LemonTeaImg },
  { title: 'Black Tea', price: 25, category: 'Beverages', description: "Relaxing and rich black tea", img: BlackTeaImg },
  { title: 'Latte Coffee', price: 55, category: 'Beverages', description: "Espresso with extra milk and foam", img: LatteCoffeeImg },
];


const MenuSection = () => {
  const [activeTab, setActiveTab] = useState('Appetizers');
  const filteredItems = menuItems.filter(item => item.category === activeTab);

  const [sectionInView, setSectionInView] = useState(false); // For overall section animation
  const [itemsInView, setItemsInView] = useState({}); // For individual item animations
  const sectionRef = useRef(null); // Ref for the main section to observe
  const itemRefs = useRef([]); // Refs for individual menu items

  // Effect for Intersection Observer for the overall section animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setSectionInView(entry.isIntersecting);
        });
      },
      { threshold: 0.1 }
    );

    const currentSection = sectionRef.current; // Capture current ref value

    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) { // Use captured value in cleanup
        observer.unobserve(currentSection);
      }
    };
  }, []); // Empty dependency array means this runs once on mount

  // Effect for Intersection Observer for individual grid items
  useEffect(() => {
    const itemObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setItemsInView(prev => ({ ...prev, [entry.target.dataset.index]: true }));
          } else {
            // Optional: reset if out of view. Remove this 'else' if you want one-time animation.
            setItemsInView(prev => ({ ...prev, [entry.target.dataset.index]: false }));
          }
        });
      },
      { threshold: 0.3 } // Trigger when 30% of item is visible
    );

    const currentItemRefs = itemRefs.current; // Capture current array of refs

    // Observe all current items
    currentItemRefs.forEach(ref => {
      if (ref) itemObserver.observe(ref);
    });

    return () => {
      // Disconnect observer on unmount or if filteredItems change
      currentItemRefs.forEach(ref => { // Use captured array in cleanup
        if (ref) itemObserver.unobserve(ref);
      });
    };
  }, [filteredItems]); // Re-run when activeTab changes and filteredItems update

  // Helper for scroll-triggered text animations (slide up, fade in) for section titles
  const getSectionAnimatedTextStyle = (delay) => ({
    transform: sectionInView ? 'translateY(0)' : 'translateY(50px)',
    opacity: sectionInView ? 1 : 0,
    transition: `transform 0.8s ease-out ${delay}s, opacity 0.8s ease-out ${delay}s`,
  });

  // Helper for scroll-triggered item animations (slide up, fade in) for grid items
  const getItemAnimatedStyle = (index) => {
    const isVisible = itemsInView[index];
    // Stagger animation for grid based on row/column
    // Adjust delay as needed, this gives a slight left-to-right, top-to-bottom feel
    const delay = (index % 2 === 0 ? 0 : 0.1) + Math.floor(index / 2) * 0.1;

    return {
      transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
      opacity: isVisible ? 1 : 0,
      transition: `transform 0.6s ease-out ${delay}s, opacity 0.6s ease-out ${delay}s`,
    };
  };

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: `
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400..900;1,400..900&display=swap');
        @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600&display=swap');

        .menu-section {
          background-color: #111;
          color: white;
          padding: 60px 20px;
          text-align: center;
          overflow: hidden; /* Hide overflow for slide-up animation */
        }
        .menu-subtitle {
          color: #d4a762;
          font-size: 18px;
          margin-bottom: 10px;
          letter-spacing: 1px;
          font-family: 'Playfair Display', serif;
          font-weight: 400;
        }
        .menu-title {
          font-size: clamp(30px, 5vw, 48px);
          margin-bottom: 30px;
          font-family: 'Playfair Display', serif;
          font-weight: normal;
          line-height: 1.2;
        }
        .menu-title span {
          color: #d4a762;
        }

        .menu-tabs-bar {
          background-color: #2F2F2F;
          border-radius: 50px;
          padding: 10px 20px;
          display: flex;
          justify-content: center;
          gap: 20px;
          margin: 0 auto 30px auto;
          max-width: fit-content;
          flex-wrap: wrap;
        }
        .menu-tab {
          padding: 8px 20px;
          background: transparent;
          border-radius: 25px;
          color: white;
          border: none;
          cursor: pointer;
          transition: color 0.3s ease, transform 0.2s ease;
          font-size: 14px;
          font-weight: bold;
          white-space: nowrap;
        }
        .menu-tab:hover {
          transform: translateY(-2px);
        }
        .menu-tab.active {
          color: #D4A762;
        }

        .menu-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 20px;
          width: 70%;
          max-width: 1200px;
          margin: 0 auto;
        }
        .menu-item {
          border-radius: 10px;
          padding: 15px;
          display: flex;
          align-items: flex-start;
          gap: 15px;
          text-align: left;
          /* Ensure item animation respects grid container */
          will-change: transform, opacity;
        }

        /* New styles for the image wrapper */
        .menu-item-image-wrapper {
          width: 80px; /* Increased size */
          height: 80px; /* Increased size */
          border-radius: 50%;
          overflow: hidden; /* Crucial for reflection */
          position: relative; /* For positioning ::after */
          flex-shrink: 0;
          /* Add perspective for 3D flip effect */
          perspective: 1000px;
        }

        .menu-item-image-wrapper img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          /* Transition for both scale and flip */
          transition: transform 0.4s ease-in-out;
          /* Preserve 3D for flip */
          transform-style: preserve-3d;
        }

        .menu-item-image-wrapper:hover img {
          transform: scale(1.05) rotateY(180deg); /* Scale and flip */
        }

        /* Mirror Effect for images (glossy sweep) */
        .menu-item-image-wrapper::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 200%; /* Wider to cover the diagonal sweep */
          height: 100%;
          background: rgba(255, 255, 255, 0.2); /* Semi-transparent white for glossy effect */
          transform: translateX(-100%) rotate(45deg); /* Start off-screen to the left, rotated */
          transition: transform 0.5s ease-out; /* Smooth transition for the effect */
          z-index: 1; /* Ensure it's above the image */
        }

        .menu-item-image-wrapper:hover::after {
          transform: translateX(100%) rotate(45deg); /* Sweep across to the right */
        }

        .menu-details {
          flex-grow: 1;
        }
        .menu-details h3 {
          margin: 0;
          font-size: 16px;
          font-family: 'Playfair Display', serif;
        }
        .menu-details p {
          font-size: 13px;
          color: #ccc;
          margin: 5px 0 0;
        }
        .menu-price {
          background-color: #d4a762;
          color: white;
          border-radius: 20px;
          font-weight: bold;
          font-size: 18px;
          margin-left: auto;
          align-self: center;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 4px;

          /* Default size for medium/small screens */
          width: 65px;
          height: 35px;
          flex-shrink: 0;
        }
        .menu-price .rupee-icon {
            font-size: 16px;
        }

        .menu-bottom-text {
          margin-top: 30px;
          color: #ccc;
          font-size: 14px;
        }
        .menu-bottom-text a {
          color: #d4a762;
        }

        /* Media query for large screens */
        @media (min-width: 1024px) { /* Adjust breakpoint as needed for "large screen" */
            .menu-price {
                width: 52px;   /* 65px - (65px * 0.20) = 52px */
                height: 28px; /* 35px - (35px * 0.20) = 28px */
                font-size: 15px; /* Adjust font size to fit smaller container */
            }
            .menu-price .rupee-icon {
                font-size: 13px; /* Adjust icon size */
            }
            /* You might also want to adjust menu-item-image-wrapper for consistency */
            .menu-item-image-wrapper {
              width: 70px; /* Reduced by ~12.5% from 80px */
              height: 70px;
            }
        }

        @media (max-width: 768px) {
          .menu-grid {
            grid-template-columns: 1fr;
            width: 100%;
            padding: 0;
            margin: 0;
          }
        }
        @media (max-width: 480px) {
          .menu-grid {
            width: 100%;
            padding: 0;
            margin: 0;
          }
          .menu-item {
            padding: 10px;
          }
          /* Adjusted for smaller screens */
          .menu-item-image-wrapper {
            width: 60px; /* Adjusted for smaller screens */
            height: 60px;
          }
          .menu-details h3 {
            font-size: 15px;
          }
          .menu-details p {
            font-size: 12px;
          }
          .menu-price {
            font-size: 16px;
            width: 60px; /* Adjusted fixed width for small screens */
            height: 30px; /* Adjusted fixed height for small screens */
          }
          .menu-price .rupee-icon {
            font-size: 14px;
          }
        }
      ` }} />
 
      <section className="menu-section" ref={sectionRef}>
        <h4
          style={{
            ...getSectionAnimatedTextStyle(0.1),
            color: '#D4A762',
            fontSize: '18px',
            marginBottom: '10px',
            letterSpacing: '1px',
            fontWeight: '500',
          }}
        >
          FROM OUR MENU
        </h4>

        <h2
          className="menu-title"
          style={{ ...getSectionAnimatedTextStyle(0.3) }}
        >
          An Inspired Menu That <br />
          <span style={{ ...getSectionAnimatedTextStyle(0.5), fontFamily: 'Playfair Display', }}>Blends Tradition</span>
        </h2>

        <div className="menu-tabs-bar">
          {menuTabs.map((tab, index) => (
            <button
              key={index}
              className={`menu-tab ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="menu-grid">
          {filteredItems.map((item, index) => (
            <div
              className="menu-item"
              key={index}
              ref={el => (itemRefs.current[index] = el)} // Attach ref for observer
              data-index={index} // Store index for state lookup
              style={getItemAnimatedStyle(index)} // Apply animation style
            >
              <div className="menu-item-image-wrapper">
                <img src={item.img} alt={item.title} />
              </div>
              <div className="menu-details">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
              <div className="menu-price">
                <span className="rupee-icon">₹</span> {item.price}
              </div>
            </div>
          ))}
        </div>

        <p className="menu-bottom-text">
          Ready To Savor The Best? <Link to="/menu">Check Our Dishes!</Link>
        </p>
      </section>
    
    </>
  );
};

export default MenuSection;